import type { SVGProps } from 'react';
const SvgLightbulbOnCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Lightbulb On Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M1.982 9.91H.661M16.518 9.91h1.321M14.39 4.772l.934-.935M4.11 4.772l-.934-.935M9.25 2.643V1.32M9.25 4.955a4.955 4.955 0 0 0-1.982 9.499v2.064c0 .365.296.66.66.66h2.643a.66.66 0 0 0 .661-.66v-2.064A4.957 4.957 0 0 0 9.25 4.955" />
    </g>
  </svg>
);
export default SvgLightbulbOnCore;
